import { jsxs, jsx } from "react/jsx-runtime";
import { motion } from "motion/react";
import React__default, { useRef } from "react";
import { cn } from "../lib/utils.js";
const StoreCarousel = ({ children, styleProps, gap = 15, ...props }) => {
  const carouselRef = useRef(null);
  const itemRefs = useRef([]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn("tw:relative tw:w-full tw:max-w-full tw:overflow-hidden tw:flex tw:justify-start tw:items-center"),
      ...styleProps,
      children: [
        /* @__PURE__ */ jsx("style", { children: `
        .store-carousel-scroll::-webkit-scrollbar {
          display: none;
        }
      ` }),
        /* @__PURE__ */ jsx(
          motion.div,
          {
            ref: carouselRef,
            style: {
              gap: `${gap}px`,
              scrollbarWidth: "none",
              // Firefox
              msOverflowStyle: "none"
              // IE/Edge
            },
            className: cn("store-carousel-scroll", "tw:flex tw:overflow-auto tw:[scroll-snap-type:x_mandatory]"),
            ...props,
            children: React__default.Children.map(children, (child, index) => /* @__PURE__ */ jsx(
              "div",
              {
                className: "tw:snap-start tw:shrink-0",
                ref: (ref) => {
                  const current = itemRefs.current[index];
                  if (current && !ref) {
                    itemRefs.current = itemRefs.current.filter((_, i) => i !== index);
                    return;
                  }
                  itemRefs.current[index] = ref;
                },
                children: child
              },
              index
            ))
          }
        )
      ]
    }
  );
};
export {
  StoreCarousel as default
};
//# sourceMappingURL=StoreCarousel.js.map
